module.exports = __webpack_public_path__ + "static/media/curve.b31badad.svg";